import { api } from "@/lib/api";

export interface SickLeave {
  id: string;
  radnik_id: string;
  worker_name: string;
  gradiliste_id: string;
  site_name: string;
  datum_od: string;
  datum_do: string | null;
  prijavio_user_id: string;
  reported_by: string;
  prijavljeno_at: string;
  stanje_doznake: "nema" | "ima" | "neslaganje";
  can_view_document: boolean;
  can_manage: boolean;
  ai_from: string | null;
  ai_to: string | null;
  days: number;
  evidence_pending_days?: number;
  ponisteno_at: string | null;
}

export interface SickLeaveInput {
  radnik_id: string;
  gradiliste_id: string;
  datum_od: string;
  datum_do: string | null;
}

export interface SickLeaveWorker {
  radnik_id: string;
  worker_name: string;
  gradiliste_id: string;
  site_name: string;
  na_bolovanju: boolean;
}

export const sickLeave = {
  workers: async (gradiliste_id?: string, signal?: AbortSignal) =>
    (await api.get<SickLeaveWorker[]>("/bolovanja/radnici", { params: { gradiliste_id }, signal })).data,
  list: async (params: { gradiliste_id?: string; month?: string; filter?: string }, signal?: AbortSignal) =>
    (await api.get<SickLeave[]>("/bolovanja", { params, signal })).data,
  create: async (data: SickLeaveInput) => (await api.post<SickLeave>("/bolovanja", data)).data,
  upload: async (id: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await api.post<SickLeave>(`/bolovanja/${id}/doznaka`, data)).data;
  },
  cancel: async (id: string, reason?: string) => { await api.post(`/bolovanja/${id}/ponisti`, { reason }); },
  end: async (id: string, datum_do: string) => { await api.patch(`/bolovanja/${id}`, { datum_do }); },
  align: async (id: string) => { await api.post(`/bolovanja/${id}/uskladi`); },
  remind: async (id: string) => { await api.post(`/bolovanja/${id}/podsjeti`); },
  content: async (id: string, signal?: AbortSignal) => (await api.get<Blob>(`/bolovanja/${id}/doznaka`, { responseType: "blob", signal })).data,
  export: async (month: string, gradiliste_id?: string) => {
    const blob = (await api.get<Blob>("/bolovanja/izvoz", { params: { month, gradiliste_id }, responseType: "blob" })).data;
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a"); link.href = url; link.download = `bolovanja-${month}.xlsx`; link.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

export const sickLeaveConfirmation = "Radnik ima bolovanje taj dan. Ipak upiši sate?";

export function previousMonth(today: string) {
  const date = new Date(`${today.slice(0, 7)}-01T12:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() - 1);
  return date.toISOString().slice(0, 7);
}
